import { ActionTypes } from '../constants/actionTypes';

const initialState = {
   loading: false,
   filterDrawerOpen : false,
   formData: {
    site_id: "",
   },
   reportList: [],
   error: null,
   sites: [],
   reportDetailsParameters : null
}

export const reportReducer = (state= initialState, {type, payload}) => {
  switch(type) {
    case ActionTypes.SET_REPORT_FILTER_DRAWER_OPEN:
        return{...state, filterDrawerOpen: payload};
    case ActionTypes.SET_FILTER_CREATE_REPORT_FORMDATA:
        return{
            ...state,
            formData: {
                ...state.formData,
                [payload.field]:payload.value
            }
        }
    case ActionTypes.SET_SITELIST:
        return{...state, sites: payload}
    case ActionTypes.RESET_FILTER_CREATE_REPORT_FORMDATA:
        return{
            ...state,
            formData: initialState.formData
            }
    case ActionTypes.FETCH_CREATE_REPORT_SUMMARY_REQUEST:
        return {...state, loading: true}
    case ActionTypes.GET_DEFAULT_REPORT_SUMMARY_DATA:
        return {...state, loading: false, reportList: payload}
    case ActionTypes.GET_REPORT_SUMMARY_DATA:
        return {...state, loading: false, reportList: payload};
    case ActionTypes.SET_REPORT_DETAILS_PARAMETERS:
        return {...state, reportDetailsParameters: payload}
    case ActionTypes.RESET_REPORT_PARAMETERS:
        return {...state, reportDetailsParameters: initialState.reportDetailsParameters}
    case ActionTypes.DISABLE_LOADING:
        return {...state, loading: false}
    default:
    return state;
  }
}